// extracted by mini-css-extract-plugin
export var aircallIframe = "_lv-3";
export var fabContainer = "_lv-5";
export var fabRinging = "_lv-6";
export var loadingOverlay = "_lv-4";
export var pulse = "_lv-7";
export var widgetContent = "_lv-2";
export var widgetPanel = "_lv-0";
export var widgetPanelExpanded = "_lv-1";